import React from "react";

export default function C_V_LATLNG({ value }) {
  // Assuming value comes in as "-6.2088, 106.8456"
  return (
    <span
      title={value}
      style={{
        display: "block",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        width: "100%",
        lineHeight: "1.5",
        fontFamily: "monospace", // Monospace is great for aligning numbers!
        fontSize: "12px",
      }}
    >
      {value || ""}
    </span>
  );
}
